import React, { useState, useRef } from "react";
import { CButton, CDropdownItem, CSpinner } from "@coreui/react";
import CIcon, { CIconSvg } from "@coreui/icons-react";
import { cilArrowThickFromBottom } from "@coreui/icons";
import * as XLSX from "xlsx";

const ExcelUploadButton = ({ label, onFileLoaded, onException }) => {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoading(true);
    const reader = new FileReader();
    reader.onload = (e) => {
      const arrayBuffer = e.target.result;
      const workbook = XLSX.read(new Uint8Array(arrayBuffer), {
        type: "array",
      });

      try {
        if (onFileLoaded) {
          onFileLoaded(workbook);
        }
      } catch (ex) {
        if (onException) {
          onException({
            title: "Ficherio",
            message: "Ocorreu um erro ao processar o ficheiro.",
            type: "error",
          });
        }
      } finally {
        setLoading(false);
        event.target.value = "";
      }
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <CDropdownItem
      className="d-flex align-items-center"
      onClick={handleButtonClick}
    >
      {loading ? (
        <>
          <CSpinner size="sm" className="me-2" /> A carregar...
        </>
      ) : (
        <>
          <svg
            x="0px"
            y="0px"
            width="25"
            height="25"
            viewBox="0 0 30 30"
            className="me-2"
            fill="#217346"
          >
            <path d="M 15 3 A 2 2 0 0 0 14.599609 3.0429688 L 14.597656 3.0410156 L 4.6289062 5.0351562 L 4.6269531 5.0371094 A 2 2 0 0 0 3 7 L 3 23 A 2 2 0 0 0 4.6289062 24.964844 L 14.597656 26.958984 A 2 2 0 0 0 15 27 A 2 2 0 0 0 17 25 L 17 5 A 2 2 0 0 0 15 3 z M 19 5 L 19 8 L 21 8 L 21 10 L 19 10 L 19 12 L 21 12 L 21 14 L 19 14 L 19 16 L 21 16 L 21 18 L 19 18 L 19 20 L 21 20 L 21 22 L 19 22 L 19 25 L 25 25 C 26.105 25 27 24.105 27 23 L 27 7 C 27 5.895 26.105 5 25 5 L 19 5 z M 23 8 L 24 8 C 24.552 8 25 8.448 25 9 C 25 9.552 24.552 10 24 10 L 23 10 L 23 8 z M 6.1855469 10 L 8.5878906 10 L 9.8320312 12.990234 C 9.9330313 13.234234 10.013797 13.516891 10.091797 13.837891 L 10.125 13.837891 C 10.17 13.644891 10.258531 13.351797 10.394531 12.966797 L 11.785156 10 L 13.972656 10 L 11.359375 14.955078 L 14.050781 19.998047 L 11.716797 19.998047 L 10.212891 16.740234 C 10.155891 16.625234 10.089203 16.393266 10.033203 16.072266 L 10.011719 16.072266 C 9.9777187 16.226266 9.9105937 16.458578 9.8085938 16.767578 L 8.2949219 20 L 5.9492188 20 L 8.7324219 14.994141 L 6.1855469 10 z M 23 12 L 24 12 C 24.552 12 25 12.448 25 13 C 25 13.552 24.552 14 24 14 L 23 14 L 23 12 z M 23 16 L 24 16 C 24.552 16 25 16.448 25 17 C 25 17.552 24.552 18 24 18 L 23 18 L 23 16 z M 23 20 L 24 20 C 24.552 20 25 20.448 25 21 C 25 21.552 24.552 22 24 22 L 23 22 L 23 20 z"></path>
          </svg>
          {label}
        </>
      )}
      <input
        type="file"
        accept=".xlsx, .xls"
        ref={fileInputRef}
        onChange={handleFileUpload}
        style={{ display: "none" }}
      />
    </CDropdownItem>
  );
};

export default ExcelUploadButton;
